<template>
  <div class="search-box col-lg-12 mb-5 p-0 m-0">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por..." aria-label="Search for..." v-model="searchText">
      <span class="input-group-btn">
        <button class="btn btn-secondary" type="button" @click="searchClicked">Pesquisar</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchText: ''          
    }
  },
  methods: {
    searchClicked()
    {
      this.$emit('search-clicked', this.searchText);
    }
  }
}
</script>
